import React from 'react';
import Helping from '../../helpers/Helping';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

const DropDown = ({
  label,
  valuesArray,
  handleOnSelect,
  handleOnSearch,
  handleOnHover,
  handleOnFocus,
  handleFormatResult,
  handleOnClear,
  userSelectedFieldValue
}) => (

  <ReactSearchAutocomplete
    className="basic-single"
    placeholder={`Select ${Helping.getTitleCase(label)}`}
    items={valuesArray}
    onSearch={handleOnSearch}
    onSelect={handleOnSelect}
    onFocus={handleOnFocus}
    formatResult={handleFormatResult}
    onClear={handleOnClear}
    fuseOptions={{ keys: ["name"] }}
    resultStringKeyName={"description"}
    inputSearchString={userSelectedFieldValue}
    maxResults={100}
    minResults={50}
    styling={
      {
      zIndex: 1,
      height: "40px",
      border: "1px solid transparent",
      borderRadius: "10px",
      backgroundColor: "#001C29",
      color: "hsl(0, 0%, 50%)",
      iconColor: "#fff",
      // clearIconMargin: "3px 8px 0 0",
    }
  }
  />
)

export default DropDown;